import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

import { SectionHeading, SETTLE_SPRING } from "./SectionHeading";

const TONES = ["bg-home-peri", "bg-home-butter", "bg-home-sky", "bg-home-blush"] as const;

export function HowStepsSection() {
  const { t } = useTranslation("home");

  const steps = ["stepOne", "stepTwo", "stepThree", "stepFour"] as const;

  return (
    <section id="how-it-works" className="scroll-mt-32 md:scroll-mt-24 px-5 py-20 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading level="utility" kicker={t("how.kicker")} title={t("how.title")} />

        <div className="relative mt-12">
          {/* Thin connecting line across the sequence */}
          <span
            aria-hidden="true"
            className="absolute top-5 right-[12%] left-[12%] hidden h-px bg-home-ink/15 md:block"
          />
          <span
            aria-hidden="true"
            className="absolute top-4 bottom-4 left-[19px] w-px bg-home-ink/15 md:hidden"
          />

          <div className="grid gap-10 md:grid-cols-4 md:gap-6">
            {steps.map((key, i) => (
              <motion.div
                key={key}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ ...SETTLE_SPRING, delay: 0.08 * i }}
                className="relative flex gap-4 md:block md:text-center"
              >
                <span
                  className={`z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-display text-base font-bold text-home-ink shadow-[0_6px_16px_-8px_rgba(33,31,28,0.3)] md:mx-auto ${TONES[i]}`}
                >
                  {i + 1}
                </span>
                <div className="md:mt-5">
                  <h3 className="font-display text-lg leading-tight font-semibold text-home-ink">
                    {t(`how.${key}Title`)}
                  </h3>
                  <p className="mt-2 font-body text-[14px] leading-relaxed text-home-ink/70">
                    {t(`how.${key}Body`)}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
